{
  "loading": "正在載入",
  "placeholder": "選取一個選項"
}